/** @jsx jsx */
import { jsx } from "theme-ui"
import PropTypes from "prop-types"

import ButtonContent, { useButtonColorSx } from "./button-content"
import { isStyledVariant } from "./button-variants"

/**
 * The call-to-action button under the blog teaser listings. Without a variant
 * it is the historical ghost button; the new variants (DEV-744/745) use the
 * shared tokens. `sx` carries the listing's sizing.
 */
const ListingButton = ({ buttonText, buttonVariant, iconRight, className }) => {
  const styledButtonSx = useButtonColorSx({ variant: buttonVariant })
  return (
    <button
      className={className}
      sx={
        isStyledVariant(buttonVariant)
          ? styledButtonSx
          : { variant: "styles.ghostButton" }
      }
    >
      <ButtonContent text={buttonText} iconRight={iconRight} />
    </button>
  )
}

ListingButton.propTypes = {
  buttonText: PropTypes.string,
  buttonVariant: PropTypes.oneOf(["primary", "secondary", "download"]),
  iconRight: PropTypes.string,
  className: PropTypes.string,
}

export default ListingButton
